import { render } from "./OnboardingPrompt.vue?vue&type=template&id=19eff57a"
import script from "./OnboardingPrompt.vue?vue&type=script&lang=js"
export * from "./OnboardingPrompt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__